import { makeStyles } from "@mui/styles";
export default makeStyles(theme=>({
    root: {
        '& .MuiFormControl-root': {
            width: '100%',
            // margin: theme.spacing(1)
        }
    }
}));